export const ItemTypes = {
  CREATIVE: "creative",
  PLAYLIST: "playlist",
  PLAYLIST_ITEM: "playlist_item",
};

export const DEFAULT_PAGE_SIZE = 30;
